import { Component, Inject } from '@angular/core';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { buildSupplierApiPath, getSupplierApiRoute, SupplierApiRouteId } from '../../../supplier-api-tester.catalog';
import {
  AvailabilityDelayUnit,
  DELAY_UNIT_LABELS,
  formatSupplierApiBody,
  HTTP_METHOD_CLASSES,
} from '../../../supplier-api-tester.models';

/** Champ à saisir avant l'envoi, ajouté au corps de la requête. */
export type ApiTesterActionInput = 'availabilityDelay' | 'selectedProfile';

export interface ApiTesterActionDialogData {
  title: string;
  /** Ce que l'API va faire, en langage métier. */
  explanation: string;
  routeId: SupplierApiRouteId;
  pathParams: Record<string, string>;
  body: Record<string, unknown>;
  input?: ApiTesterActionInput;
  /** Action de refus : bouton d'envoi en rouge. */
  danger?: boolean;
}

/**
 * Confirmation d'une action d'écriture : montre l'appel exact qui va partir (verbe, chemin, corps JSON)
 * et recueille les champs facultatifs. Renvoie le corps à envoyer, ou rien si le testeur annule.
 */
@Component({
  selector: 'vex-api-tester-action-dialog',
  templateUrl: './api-tester-action-dialog.component.html',
  styleUrls: ['../api-tester-shared.scss'],
})
export class ApiTesterActionDialogComponent {
  readonly route = getSupplierApiRoute(this.data.routeId);
  readonly path = buildSupplierApiPath(this.route, this.data.pathParams);
  readonly methodClass = HTTP_METHOD_CLASSES[this.route.method];
  readonly delayUnits = Object.entries(DELAY_UNIT_LABELS);

  delayValue: number | null = null;
  delayUnit: AvailabilityDelayUnit = 'days';
  selectedProfile = '';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ApiTesterActionDialogData,
    private readonly dialogRef: MatDialogRef<ApiTesterActionDialogComponent, Record<string, unknown>>,
  ) {}

  get requestBody(): Record<string, unknown> {
    if (this.data.input === 'availabilityDelay' && this.delayValue != null && `${this.delayValue}` !== '') {
      return { ...this.data.body, availabilityDelay: { value: Number(this.delayValue), unit: this.delayUnit } };
    }
    if (this.data.input === 'selectedProfile') {
      return { ...this.data.body, interimData: { selectedProfile: this.selectedProfile.trim() } };
    }
    return this.data.body;
  }

  get requestBodyText(): string {
    return formatSupplierApiBody(this.requestBody);
  }

  canSend(): boolean {
    return this.data.input !== 'selectedProfile' || !!this.selectedProfile.trim();
  }

  send(): void {
    this.dialogRef.close(this.requestBody);
  }
}
